module.exports = __webpack_public_path__ + "static/media/24.f91a8964.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/shoes/24.png
// module id = 1065
// module chunks = 0